module.exports = __webpack_public_path__ + "img/ppt.00aab7af.jpg";